import React from 'react';
// libraries and components
import SVG from "react-inlinesvg";
// assets
import { phoneSVG } from '../../../../shared/helpers/icons';
// styles
import styles from './callHandler.module.scss';

const CallHandler = ({
    number,
    callState,
    showHungUpButton,
    showAcceptButton,
    handleHangUp,
    handleAccept
}) => {

    return(
        <>
            <div className={styles.onCallContainer}>
                <div className={styles.recipientContainer}>
                        <div className={styles.recipient}> 
                            {number.length > 14 ? `${number.slice(0,14)}...` : number} 
                        </div>
                        <span className={styles.callState}>
                        {
                            callState
                        }
                        </span>
                        
                    </div>
                <div className={styles.buttonContainer}>
                    {
                        showAcceptButton && 
                        <button className={styles.acceptCall} onClick={ handleAccept }> 
                            <SVG src={phoneSVG}/>
                        </button>
                    }
                    {
                        showHungUpButton && 
                        <button className={styles.hungUpButton} onClick={ handleHangUp }> 
                            <SVG src={phoneSVG}/>
                        </button>
                    }
                    
                </div>
            </div>
        </>
    )
};
export default CallHandler;